module.exports = "/static/media/convert_icon.e51b3c4b.svg";